import { dataHooks } from '../../../../libs/dataHooks';

export const tooltipDataHooks = dataHooks<{ content: {} }>('tooltip');
